import React, { useState, useEffect } from "react";
import "./AdminProducts.css";
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate } from "react-router-dom";
import { Button, Navbar, Nav, Container, Row, Col, Card, Table, Form, Dropdown, Pagination } from "react-bootstrap";
// import dash from "../src/Photos/Dashboard.png";
// import menu from "../src/Photos/Menu.png";
// import { IoIosArrowForward } from "react-icons/io";
import Account from "../src/Photos/Account.png";
import Logo from "../src/Photos/eximtracfinallogo.png";

import { hasAccess } from "../src/roleAccess.js";

function AdminProducts() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    // const [toggled, setToggled] = React.useState(false);



    // const [showModal, setShowModal] = useState(false);
    // const [file, setFile] = useState(null); // State to hold the uploaded file
    // const [successMessage, setSuccessMessage] = useState(false);

    // // Show/Hide Modal
    // const handleShowModal = () => setShowModal(true);
    // const handleCloseModal = () => setShowModal(false);

    // // Handle file input
    // const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    // };

    // // Function to handle the file upload and show success message
    // const handleAddCategory = () => {
    //     if (file) {
    //         console.log('File uploaded:', file);
    //         setSuccessMessage(true);  // Show success message
    //         setTimeout(() => setSuccessMessage(false), 3000);  // Hide message after 3 seconds
    //         setShowModal(false);  // Close the modal
    //     }
    // };




    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState("");

    // Handle file selection
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    // Handle file upload to the backend
    const handleFileUpload = async (event) => {
        event.preventDefault();
        if (!file) {
            setUploadStatus("Please select a CSV file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            // const token = localStorage.getItem("adminToken");
            const response = await fetch("https://api-ft5g.onrender.com/upload-csv", {
                method: "POST",
                body: formData,
                // "Authorization": `Bearer ${token}`,
            });

            if (response.ok) {
                setUploadStatus("File uploaded successfully!");
            } else {
                const errorResponse = await response.json();
                setUploadStatus(`Upload failed: ${errorResponse.message}`);
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setUploadStatus("An error occurred while uploading the file.");
        }
    };




    const [editProduct, seteditProduct] = useState({
        oldSKUCode: "",
        SKUCode: "",
        productName: "",
        unitPerCarton: "",
        unit: "",
        weightPerPkt: "",
        unitMeasurement: "",
        unitMeasurementType: "",
        categoryName: "",
        subCategoryName: "",
        brandName: ""
    });


    // Handle edit category input change
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        seteditProduct((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle edit button click
    const handleEditClick = (product) => {
        console.log("Editing product:", product);  // ✅ DEBUG
        seteditProduct({
            oldSKUCode: product.SKU_CODE, // You can also use oldName if preferred
            SKUCode: product.SKU_CODE,
            productName: product.PRODUCT_DESCRIPTION,
            unitPerCarton: product.UNIT_PER_CTN,
            unit: product.UNIT,
            weightPerPkt: product.WEIGHT_PER_PKT_GRAMS,
            unitMeasurement: product.UNIT_MEASUREMENT,
            unitMeasurementType: product.UNIT_MEASUREMENT_TYPE,
            categoryName: product.CATEGORY,
            subCategoryName: product.SUB_CATEGORY,
            brandName: product.BRAND,
        });
    };


    // Handle update category
    const handleUpdateProduct = (e) => {
        e.preventDefault();

        // const token = localStorage.getItem("adminToken");
        fetch('https://api-ft5g.onrender.com/update-product', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(editProduct)
        })
            .then(response => response.json())
            .then(data => {
                alert(data.message);
                // Update local state or reload data
            })
            .catch(error => {
                console.error('Error updating product:', error);
                alert('Update failed');
            });
    };


    // const [filterVal, setFilterVal] = useState('');
    // const [ApiData, setApiData] = useState([]);
    const [input, setData] = useState([]); // All paginated products
    const [filteredData, setFilteredData] = useState([]); // For filtered display
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(50); // Fixed limit
    const [totalPages, setTotalPages] = useState(1); // 🔁 Set from backend

    // Filter list
    const [ApiData, setApiData] = useState([]); // Categories
    const [ApiData2, setApiData2] = useState([]); // Sub-Categories
    const [ApiData3, setApiData3] = useState([]); // Brands

    const [category, setCategory] = useState(''); // Category filter state
    const [subCategory, setSubCategory] = useState(''); // Sub-category filter state
    const [brand, setBrand] = useState(''); // Brand filter state

    const [searchTerm, setSearchTerm] = useState('');

    // Fetch products on mount and when currentPage changes
    useEffect(() => {
        const fetchData = async () => {
            try {
                let url = `https://api-ft5g.onrender.com/GetAllProducts?page=${currentPage}&limit=${limit}`;
                if (category && category !== 'SELECT') url += `&category=${category}`;
                if (subCategory && subCategory !== 'SELECT') url += `&subCategory=${subCategory}`;
                if (brand && brand !== 'SELECT') url += `&brand=${brand}`;
                if (searchTerm.trim()) url += `&search=${searchTerm.trim()}`;

                const response = await fetch(url);
                const docs = await response.json();

                if (docs && docs.data) {
                    setData(docs.data);
                    setFilteredData(docs.data);
                    setTotalPages(docs.totalPages);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setData([]);
                setFilteredData([]);
            }
        };

        fetchData();
    }, [currentPage, limit, category, subCategory, brand, searchTerm]);


    // Fetch Categories
    useEffect(() => {
        const fetchCategories = async () => {
            const token = localStorage.getItem("adminToken");

            try {
                const res = await fetch('https://api-ft5g.onrender.com/AdminGetCategory', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const docs = await res.json();
                setApiData(docs.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    // Fetch Sub-Categories independently or with Category
    useEffect(() => {
        const fetchSubCategories = async () => {
            const token = localStorage.getItem("adminToken");

            let url = 'https://api-ft5g.onrender.com/AdminGetSubCategory';
            if (category) {
                url += `?category=${category}`;
            }

            try {
                const res = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const docs = await res.json();
                setApiData2(docs.data || []);
            } catch (error) {
                console.error("Error fetching sub-categories:", error);
                setApiData2([]);
            }
        };

        fetchSubCategories();
    }, [category]);

    // Fetch Brands independently or with Category/SubCategory
    useEffect(() => {
        const fetchBrands = async () => {
            const token = localStorage.getItem("adminToken");

            let url = 'https://api-ft5g.onrender.com/AdminGetBrand';
            const query = [];

            if (category) query.push(`category=${category}`);
            if (subCategory) query.push(`subCategory=${subCategory}`);
            if (query.length > 0) url += `?${query.join('&')}`;

            try {
                const res = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const docs = await res.json();
                setApiData3(docs.data || []);
            } catch (error) {
                console.error("Error fetching brands:", error);
                setApiData3([]);
            }
        };

        fetchBrands();
    }, [category, subCategory]);


    // Handle Filtering Logic
    const handleFilter = () => {
        setCurrentPage(1); // API will handle filtering now
    };


    const resetFilters = () => {
        setCategory("");
        setSubCategory("");
        setBrand("");
        setSearchTerm("");
        setFilteredData(input);
        setCurrentPage(1);
    };

    const paginatedData = filteredData; // filteredData already contains only current page's data


    //For Image Upload
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [ImageuploadStatus, setImageUploadStatus] = useState("");

    const handleImageFileChange = (event) => {
        setSelectedFiles(event.target.files);
    };

    const handleUpload = async () => {
        if (selectedFiles.length === 0) {
            alert("Please select images to upload.");
            return;
        }

        const formData = new FormData();

        // Append all selected files
        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append("images", selectedFiles[i]);
        }

        try {
            // const token = localStorage.getItem("adminToken");
            const response = await fetch("https://api-ft5g.onrender.com/upload-images", {
                method: "POST",
                body: formData,
                // "Authorization": `Bearer ${token}`,
            });

            const data = await response.json();

            if (response.ok) {
                setImageUploadStatus("Images uploaded successfully!");
            } else {
                setImageUploadStatus(`Error: ${data.error}`);
            }
        } catch (error) {
            console.error("Upload failed:", error);
            setImageUploadStatus("Failed to upload images.");
        }
    };


    const [products, setProducts] = useState([]);
    const [selectedIDs, setSelectedIDs] = useState([]);

    // Fetch products
    const fetchProducts = async () => {
        try {
            const res = await fetch('https://api-ft5g.onrender.com/GetAllProducts'); // Replace with your GET API
            const data = await res.json();
            setProducts(data);
        } catch (err) {
            console.error('Error fetching products:', err);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    // Handle single product delete
    const handleSingleDelete = async (ID) => {
        if (!window.confirm(`Are you sure to delete product: ${ID}?`)) return;

        try {
            // const token = localStorage.getItem("adminToken");
            const res = await fetch(`https://api-ft5g.onrender.com/admin-products-delete/${ID}`, {
                method: 'DELETE',
                // "Authorization": `Bearer ${token}`,
            });

            if (res.ok) {
                fetchProducts();
            } else {
                const error = await res.json();
                alert(error.message || 'Failed to delete product.');
            }
        } catch (err) {
            console.error('Delete error:', err);
        }
    };

    // Handle multiple delete
    const handleMultipleDelete = async () => {
        if (selectedIDs.length === 0) return alert('No products selected');

        if (!window.confirm(`Delete ${selectedIDs.length} selected product(s)?`)) return;

        try {
            // const token = localStorage.getItem("adminToken");
            const res = await fetch('https://api-ft5g.onrender.com/admin-products-delete-multiple', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ID: selectedIDs }),
                // "Authorization": `Bearer ${token}`,
            });

            if (res.ok) {
                setSelectedIDs([]);
                fetchProducts();
            } else {
                alert('Failed to delete selected products.');
            }
        } catch (err) {
            console.error('Multiple delete error:', err);
        }
    };

    // Toggle SKU selection
    const toggleSelection = (ID) => {
        setSelectedIDs((prev) =>
            prev.includes(ID) ? prev.filter(code => code !== ID) : [...prev, ID]
        );
    };

    const toggleSelectAll = (e) => {
        setSelectedIDs(prev => {
            const currentIDs = filteredData.map(item => item.ID);
            return e.target.checked
                ? [...new Set([...prev, ...currentIDs])]
                : prev.filter(code => !currentIDs.includes(code));
        });
    };

    useEffect(() => {
        if (uploadStatus) {
            const timer = setTimeout(() => {
                setUploadStatus("");
            }, 5000); // clear after 5 seconds

            return () => clearTimeout(timer);
        }
    }, [uploadStatus]);



    const [images, setImages] = useState([]);
    const [productImages, setProductImages] = useState({});

    useEffect(() => {
        const fetchAllImages = async () => {
            const token = localStorage.getItem("adminToken"); // or "adminToken" if you're using admin access
            if (!token) {
                console.warn("Token not found. Please login.");
                return;
            }

            const imagesMap = {};

            for (let item of paginatedData) {
                try {
                    const res = await fetch(`https://api-ft5g.onrender.com/api/product-images/${item.SKU_CODE}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (!res.ok) {
                        throw new Error(`Failed to fetch images for ${item.SKU_CODE}. Status: ${res.status}`);
                    }

                    const data = await res.json();
                    imagesMap[item.SKU_CODE] = data; // array of images
                } catch (error) {
                    console.error(`Failed to fetch images for ${item.SKU_CODE}`, error);
                }
            }

            setProductImages(imagesMap);
        };

        if (paginatedData.length > 0) {
            fetchAllImages();
        }
    }, [paginatedData]);


    const handleDelete = async (imageId) => {
        const confirm = window.confirm("Are you sure you want to delete this image?");
        if (!confirm) return;

        // const token = localStorage.getItem("adminToken");
        const res = await fetch(`https://api-ft5g.onrender.com/api/product-image-delete/${imageId}`, {
            method: 'DELETE',
            // "Authorization": `Bearer ${token}`,
        });

        if (res.ok) {
            alert("Image deleted");
            setImages(images.filter(img => img.id !== imageId));
        } else {
            alert("Failed to delete image");
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };

    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Products Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <Container fluid>
                <Row className="mb-5">
                    <Col className="mt-3 apfilter">
                        <Card className="filtercard">
                            <Row className="px-3 mb-1">
                                {/* Category Filter */}
                                <Col lg={1} xs={3} className="mt-4">
                                    <Form.Label htmlFor="categorySelect" className="filtertext">Category</Form.Label>
                                </Col>
                                <Col lg={2} xs={3} className="mt-3">
                                    <Form.Select
                                        id="categorySelect"
                                        aria-label="Select Category"
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                    >
                                        <option value="">SELECT</option>
                                        {ApiData.map((name, index) => (
                                            <option key={index} value={name.name}>
                                                {name.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                {/* Sub-Category Filter */}
                                <Col lg={1} xs={3} className="mt-4">
                                    <Form.Label htmlFor="subCategorySelect" className="filtertext">Sub - Category</Form.Label>
                                </Col>
                                <Col lg={2} xs={3} className="mt-3">
                                    <Form.Select
                                        id="subCategorySelect"
                                        aria-label="Select Sub-Category"
                                        value={subCategory}
                                        onChange={(e) => setSubCategory(e.target.value)}
                                    >
                                        <option value="">SELECT</option>
                                        {ApiData2.map((name, index) => (
                                            <option key={index} value={name.SUB_CATEGORY}>
                                                {name.SUB_CATEGORY}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                {/* Brand Filter */}
                                <Col lg={1} xs={3} className="mt-4">
                                    <Form.Label htmlFor="brandSelect" className="filtertext">Brands</Form.Label>
                                </Col>
                                <Col lg={2} xs={3} className="mt-3">
                                    <Form.Select
                                        id="brandSelect"
                                        aria-label="Select Brand"
                                        value={brand}
                                        onChange={(e) => setBrand(e.target.value)}
                                    >
                                        <option value="">SELECT</option>
                                        {ApiData3.map((name, index) => (
                                            <option key={index} value={name.BRAND}>
                                                {name.BRAND}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                {/* Buttons */}
                                <Col className="mt-3" lg={1} xs={3}>
                                    <Button onClick={handleFilter} className="applyfilterbtn">
                                        Apply Filter
                                    </Button>
                                </Col>

                                <Col className="mt-3" lg={1} xs={1}>
                                    <Button onClick={resetFilters} className="resetbtn ms-2 applyfilterbtn">
                                        Reset
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Container fluid className="mt-3">
                <Row>
                    <Col className="mt-3">
                        <Card className="mt-5">
                            <Row className="p-3">
                                <Col lg={7}>
                                    <p className="adminproducts">Products</p>
                                </Col>

                                {/* Success message */}
                                {/* {successMessage && (
                                    <Alert variant="success" className="text-center">
                                        CSV Uploaded Successfully!
                                    </Alert>
                                )} */}

                                <Col lg={5} className="">
                                    {/* <Button className="brandaddnewcatebtn" onClick={handleShowModal}>
                                        <Link className="brandaddnewcatelink"> */}
                                    <Form onSubmit={handleFileUpload}>
                                        <Form.Label htmlFor="csvFile" className="brandaddnewcatebtn">
                                            Add New Products Select a CSV File:
                                        </Form.Label>
                                        <input
                                            type="file"
                                            id="csvFile"
                                            accept=".csv"
                                            onChange={handleFileChange}
                                            className="mt-3"
                                        />
                                        <Button type="submit" className="uploadbtn mt-3">
                                            Upload
                                        </Button>
                                    </Form>
                                    {uploadStatus && (
                                        <div
                                            className={`mt-2 p-2 rounded ${uploadStatus.includes("successfully")
                                                ? "bg-success text-white"
                                                : "bg-danger text-white"
                                                }`}
                                        >
                                            {uploadStatus}
                                        </div>
                                    )}
                                    {/* </Link>
                                    </Button> */}
                                </Col>
                            </Row>

                            {/* Modal for uploading CSV */}
                            {/* <Modal show={showModal} onHide={handleCloseModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Upload Complete CSV</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formFile">
                                            <Form.Label>Upload CSV</Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept=".csv"
                                                onChange={handleFileChange}  // File input handler
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="success" onClick={handleAddCategory}>
                                        Add
                                    </Button>
                                </Modal.Footer>
                            </Modal> */}


                            {/* Edit brand modal */}
                            {editProduct.oldSKUCode && (
                                <div className="px-3 mb-4">
                                    <h4>Edit Product</h4>
                                    <form onSubmit={handleUpdateProduct}>
                                        <div className="mb-2">
                                            <label>
                                                Old SKU Code:
                                                <input
                                                    type="text"
                                                    value={editProduct.oldSKUCode}
                                                    disabled
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                New SKU Code:
                                                <input
                                                    type="text"
                                                    name="SKUCode"
                                                    value={editProduct.SKUCode}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                    required
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Product Name:
                                                <input
                                                    type="text"
                                                    name="productName"
                                                    value={editProduct.productName}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                    required
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Unit Per Carton:
                                                <input
                                                    type="number"
                                                    name="unitPerCarton"
                                                    value={editProduct.unitPerCarton}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Unit:
                                                <input
                                                    type="text"
                                                    name="unit"
                                                    value={editProduct.unit}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Weight Per Pkt:
                                                <input
                                                    type="number"
                                                    name="weightPerPkt"
                                                    value={editProduct.weightPerPkt}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Unit Measurement:
                                                <input
                                                    type="text"
                                                    name="unitMeasurement"
                                                    value={editProduct.unitMeasurement}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Unit Measurement Type:
                                                <input
                                                    type="text"
                                                    name="unitMeasurementType"
                                                    value={editProduct.unitMeasurementType}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Category Name:
                                                <input
                                                    type="text"
                                                    name="categoryName"
                                                    value={editProduct.categoryName}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Subcategory Name:
                                                <input
                                                    type="text"
                                                    name="subCategoryName"
                                                    value={editProduct.subCategoryName}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <div className="mb-2">
                                            <label>
                                                Brand Name:
                                                <input
                                                    type="text"
                                                    name="brandName"
                                                    value={editProduct.brandName}
                                                    onChange={handleEditChange}
                                                    className="mx-2"
                                                />
                                            </label>
                                        </div>

                                        <Button type="submit" variant="success" className="mt-3">
                                            Update Product
                                        </Button>
                                    </form>
                                </div>
                            )}


                            <Row className="px-3 my-3">
                                <Col lg={3} xs={8}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by Product / Category / Sub-Category / Brand..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Col>
                                <Col xs="auto">
                                    <Button onClick={handleFilter} className="applyfilterbtn">Search</Button>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="mb-5">
                                    <div className="upload-container">
                                        <h4>Upload Product Images</h4>
                                        <input type="file" multiple onChange={handleImageFileChange} />

                                        <Row>
                                            <Col className="mt-3">
                                                <Button onClick={handleUpload} className="upload-button">Upload Images</Button>
                                            </Col>
                                        </Row>
                                        {ImageuploadStatus && <p className="status-message">{ImageuploadStatus}</p>}
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="px-4">
                                    <Button
                                        className="btn btn-danger mb-2"
                                        onClick={handleMultipleDelete}
                                        disabled={selectedIDs.length === 0}
                                    >
                                        Delete Selected
                                    </Button>
                                </Col>
                            </Row>

                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={filteredData.length > 0 && filteredData.every(item => selectedIDs.includes(item.ID))}
                                                onChange={toggleSelectAll}
                                            />
                                        </th>
                                        <th>Sr No</th>
                                        <th>SKU Code</th>
                                        <th>Product Name</th>
                                        <th>Unit Per Carton</th>
                                        <th>Unit</th>
                                        <th>Weight Per Pkt Gms</th>
                                        <th>Unit Measurement</th>
                                        <th>Unit Measurement Type</th>
                                        <th>Category Name</th>
                                        <th>SubCategory Name</th>
                                        <th>Brand Name</th>
                                        <th>Image</th>
                                        <th>Action</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginatedData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIDs.includes(item.ID)}
                                                    onChange={() => toggleSelection(item.ID)}
                                                />
                                            </td>
                                            {/* <td>{(currentPage - 1) * limit + index + 1}</td> */}
                                            <td>{item.ID}</td>
                                            <td>{item.SKU_CODE}</td>
                                            <td>{item.PRODUCT_DESCRIPTION}</td>
                                            <td>{item.UNIT_PER_CTN}</td>
                                            <td>{item.UNIT}</td>
                                            <td>{item.WEIGHT_PER_PKT_GRAMS}</td>
                                            <td>{item.UNIT_MEASUREMENT}</td>
                                            <td>{item.UNIT_MEASUREMENT_TYPE}</td>
                                            <td>{item.CATEGORY}</td>
                                            <td>{item.SUB_CATEGORY}</td>
                                            <td>{item.BRAND}</td>
                                            <td>
                                                {Array.isArray(productImages[item.SKU_CODE]) ? (
                                                    productImages[item.SKU_CODE].map((img) => (
                                                        <div key={img.id} style={{ display: 'inline-block', margin: '10px' }}>
                                                            <img
                                                                src={img.base64}
                                                                alt="Product"
                                                                style={{ width: 100, height: 100, objectFit: 'cover' }}
                                                            />
                                                            <br />
                                                            <Button onClick={() => handleDelete(img.id)} variant="danger">Delete</Button>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <span>No image</span>
                                                )}
                                            </td>

                                            <td>
                                                <Button variant="success" onClick={() => handleEditClick(item)}>
                                                    Edit
                                                </Button>
                                            </td>

                                            <td>
                                                <Button variant="danger" onClick={() => handleSingleDelete(item.ID)}>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {totalPages > 1 && (
                                <div className="d-flex justify-content-center mt-3">
                                    <Pagination>
                                        {/* Previous Button */}
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => setCurrentPage(currentPage - 1)}
                                        />

                                        {/* Always show first page */}
                                        <Pagination.Item
                                            active={currentPage === 1}
                                            onClick={() => setCurrentPage(1)}
                                        >
                                            1
                                        </Pagination.Item>

                                        {/* Left Ellipsis */}
                                        {currentPage > 4 && <Pagination.Ellipsis disabled />}

                                        {/* Pages around currentPage */}
                                        {Array.from({ length: 5 }, (_, idx) => {
                                            const page = currentPage - 2 + idx;
                                            if (page > 1 && page < totalPages) {
                                                return (
                                                    <Pagination.Item
                                                        key={page}
                                                        active={page === currentPage}
                                                        onClick={() => setCurrentPage(page)}
                                                    >
                                                        {page}
                                                    </Pagination.Item>
                                                );
                                            }
                                            return null;
                                        })}

                                        {/* Right Ellipsis */}
                                        {currentPage < totalPages - 3 && <Pagination.Ellipsis disabled />}

                                        {/* Always show last page */}
                                        {totalPages > 1 && (
                                            <Pagination.Item
                                                active={currentPage === totalPages}
                                                onClick={() => setCurrentPage(totalPages)}
                                            >
                                                {totalPages}
                                            </Pagination.Item>
                                        )}

                                        {/* Next Button */}
                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => setCurrentPage(currentPage + 1)}
                                        />
                                    </Pagination>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container >
            {/* </div > */}
        </>
    );
}

export default AdminProducts;